module.exports = __webpack_public_path__ + "assets/b243825161ba0ef20a9709acb45753d5.woff";


/*****************
 ** WEBPACK FOOTER
 ** ./~/@ergeon/erg-theme/app/fonts/Gotham-Book.woff
 ** module id = 1734
 ** module chunks = 1
 **/